import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { InventoryService } from '../../../services/inventory.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup, FormControl, ValidationErrors } from '@angular/forms';

@Component({
	selector: 'app-productline-autocomplete',
	templateUrl: './productline-autocomplete.component.html',
	styleUrls: ['./productline-autocomplete.component.scss']
})

export class ProductlineAutocompleteComponent implements OnInit, OnChanges {
	@Output() value_selected = new EventEmitter < any > ();
	@Input() category: any = '';
	@Input() supplier: any = '';
	searchInput = new FormControl('');
	searching = false
	searchsubscription: any = false;
	loadsubscription: any = false;
	allResults: any = false;
	filteredItems: any = false;
	field_label = 'Product Line'
	keys = 'line_field,line_description';

	constructor(private globalSearchService: GlobalSearchService, private inventoryService: InventoryService) {}

	ngOnInit(): void {
		this.loadProductlines();

		this.searchInput.valueChanges.subscribe(newValue => {
			this.search()
		})
	}

	ngOnChanges(changes: SimpleChanges): void {
		const categoryChanged = changes['category'] && !changes['category'].firstChange;
		const supplierChanged = changes['supplier'] && !changes['supplier'].firstChange;
		if (categoryChanged || supplierChanged) {
			this.searchInput.setValue('');
			this.value_selected.emit('');
			this.loadProductlines();
		}
	}

	loadProductlines(): void {
		if (this.loadsubscription) {
			this.loadsubscription.unsubscribe();
		}
		this.searching = true;
		this.loadsubscription = this.inventoryService.getItemProductlines({ category: this.category || '', supplier: this.supplier || '' }).subscribe(c => {
			this.searching = false;
			this.allResults = c;
			this.filteredItems = c;
		})
	}

	selectValue(value: any) {
		this.value_selected.emit(this.searchInput.value)
	}


	search() {

		if (this.searchsubscription) {
			this.searchsubscription.unsubscribe();
		}

		const searchvalue = this.searchInput.value;
		if (this.searchInput.value == '') {
			this.filteredItems = this.allResults;
			this.value_selected.emit('');
		} else {
			this.filteredItems = this.globalSearchService.filterItem(this.allResults, this.searchInput.value, this.keys)
		}
	}

	displayFn(value: any) {

		if (!value) {
			return '';
		}

		return value.line_field + '-' + value.line_description
	}

}
